import request from '@/utils/request'


export const getInfo = (data) => request.post('/apis/api/users/index', data);  //信息回显

export const cardType = (data) => request.post('/apis/api/users/cardtype', data);  //证照类型

export const saveMsg = (data) => request.post('/apis/api/users/editPost', data);  //保存个人信息

export const upImage = (data) => request.post('/apis/api/users/upload', data);  //上传检测图片

export const share = (data) => request.post('https://zbj.cnautonews.com/weixin/shareinit', data);  //分享

export const xieyiCheck = (data) => request.post('/apis/api/users/selChecked', data);  //查询协议状态

export const xieyiSave = (data) => request.post('/apis/api/users/editChecked', data);  //修改协议状态

export const streetList = (data) => request.post('/apis/api/users/streetlist', data);  //查询街道

export const showInfo = (data) => request.post('/apis/api/users/showinfo', data);  //查询组织信息

export const msgBind = (data) => request.post('/apis/api/users/bind', data);  //绑定组织信息

export const msgList = (data) => request.post('/apis/api/users/clist', data);  //查询组织列表

export const msgRemoveBind = (data) => request.post('/apis/api/users/remove_bind', data);  //解绑组织

export const productList = (data) => request.post('/apis/api/test/product_list', data);  //查询产品